import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../utils/AuthContext'; // Assuming you have an auth context
import { getUserById } from '../services/api';

const UserProfile = () => {
  const { user_id } = useParams();
  const { currentUser } = useAuth(); // Get logged-in user info
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        setError('');
        
        // const response = await getUserById(user_id);
        const response = await axios.get(`https://erp-server-3qrl.onrender.com/api/users/${user_id}`, {
        // const response = await axios.get(`http://localhost:5000/api/users/${user_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });

        setUserData(response.data);
      } catch (err) {
        if (err.response) {
          switch (err.response.status) {
            case 401:
              setError('Please log in to view this profile');
              break;
            case 403:
              setError('You do not have permission to view this profile');
              break;
            case 404:
              setError('User not found');
              break;
            default:
              setError(err.response.data.message || 'Failed to fetch user data');
          }
        } else {
          setError('Network error - please try again later');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [user_id]);

  if (loading) return <div className="text-center py-8">Loading profile...</div>;
  if (error) return <div className="text-red-500 text-center py-8">{error}</div>;
  if (!userData) return <div className="text-center py-8">No user data found</div>;

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">User Profile</h2>
      
      <div className="space-y-4">
        <div>
          <label className="block text-gray-600">Name:</label>
          <p className="font-medium">{userData.fullname || 'Not provided'}</p>
        </div>
        
        <div>
          <label className="block text-gray-600">Email:</label>
          <p className="font-medium">{userData.email}</p>
        </div>
        
        <div>
          <label className="block text-gray-600">Phone:</label>
          <p className="font-medium">{userData.phone || 'Not provided'}</p>
        </div>
        
        <div>
          <label className="block text-gray-600">Role:</label>
          <p className="font-medium capitalize">{userData.role}</p>
        </div>
        
        {/* Only show edit button for own profile or super_admin */}
        {/* {(currentUser?._id === user_id || currentUser?.role === 'super_admin') && (
          <button
            className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            onClick={() => {}}
          >
            Edit Profile
          </button>
        )} */}
      </div>
    </div>
  );
};

export default UserProfile;